import { ComplaintClient } from '../complaint/complaint-client.model';
import { ComplaintAddress } from '../complaint/complaint-address.model';
import { ServiceRequestClient } from './service-request-client.model';
import { ServiceRequestAddress } from './service-request-address.model';

export class ServiceRequestInsert {
    /**Código de tipo de servicio */
    public typeCode: string;
    /**Nombre de tipo de servicio */
    public typeName: string;
    /**Código de horario de visita */
    public visitScheduleCode: string;
    /**Nombre de horario de visita */
    public visitScheduleName: string;
    /**Referencia */
    public reference: string;
    public clauseAccepted: boolean;
    /**Solicitante */
    public applicant: ServiceRequestClient;
    /**Dirección de solicitud */
    public address: ServiceRequestAddress;
}